import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);


export default new Vuetify({
    theme: {
        dark: true,
        options: { customProperties: true },
        themes: {
            name: "default",
            background: "bg4.2.jpg",
        }
        // themes: {
        //     light: {
        //         primary: '#1976D2',
        //         secondary: '#424242',
        //         accent: '#82B1FF',
        //         error: '#FF5252',
        //         info: '#2196F3',
        //         success: '#4CAF50',
        //         warning: '#FFC107',
        //     },
        //     dark: {
        //         primary: '#9C27B0',
        //         secondary: '#424242',
        //         accent: '#82B1FF',
        //         error: '#FF5252',
        //         info: '#2196F3',
        //         success: '#4CAF50',
        //         warning: '#FFC107',
        //     },
        // }
    }
});

// export default new Vuetify({
    // theme: {
    //     dark: true,
    //     themes: {
    //         light: {
    //             primary: "#6e52a1",
    //             secondary: colors.grey.darken1,
    //             accent: colors.shades.black,
    //             error: colors.red.accent3,
    //         },
    //         dark: {
    //             primary: '#6e52a1',
    //             secondary: '#424242',
    //             accent: '#FF4081',
    //             error: '#FF5252',
    //             info: '#2196F3',
    //             success: '#4CAF50',
    //             warning: '#FB8C00',
    //         },
    //     },
    //     options: {
    //         customProperties: true
    //     },
    // },

// });
